<template>
  <div class="column">
      <p class="">{{ today }}</p>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { formatDateTH } from "@/utils/date";

const today = ref("");

let timer = null;

const updateTime = () => {
  today.value = formatDateTH();
};

onMounted(() => {
  updateTime();
  timer = setInterval(updateTime, 1000);
});

onUnmounted(() => {
  clearInterval(timer);
});
</script>
